<template>
	<div class="purchase-page">
		<Loader :show="loading" />

		<template v-if="!loading && transaction">
			<div class="purchase-head">
				<template v-if="transaction.status == 'PAID'">
					<h2 class=" mt-3 mb-2">Detalle de transacción</h2>
					<div class="svg-box">
						<svg class="circular green-stroke">
							<circle
								class="path"
								cx="75"
								cy="75"
								r="50"
								fill="none"
								stroke-width="5"
								stroke-miterlimit="10"
							/>
						</svg>
						<svg class="checkmark green-stroke">
							<g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-489.57,-205.679)">
								<path
									class="checkmark__check"
									fill="none"
									d="M616.306,283.025L634.087,300.805L673.361,261.53"
								/>
							</g>
						</svg>
					</div>
					<h3 class=" mt-3 mb-2">Pago realizado correctamente</h3>
				</template>
				<template v-if="transaction.status == 'FAILED'">
					<h5 class=" mt-3 mb-2">Pago fallido</h5>
					<div class="svg-box">
						<svg class="circular red-stroke">
							<circle
								class="path"
								cx="75"
								cy="75"
								r="50"
								fill="none"
								stroke-width="5"
								stroke-miterlimit="10"
							/>
						</svg>
						<svg class="cross red-stroke">
							<g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
								<path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none" />
							</g>
							<g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
								<path class="second-line" d="M634.087,300.805L673.361,261.53" />
							</g>
						</svg>
					</div>
				</template>
				<template v-if="transaction.status == 'PENDING'">
					<h5 class=" mt-3 mb-2">Pago pendiente de acreditación</h5>
					<div class="svg-box">
						<svg class="circular yellow-stroke">
							<circle
								class="path"
								cx="75"
								cy="75"
								r="50"
								fill="none"
								stroke-width="5"
								stroke-miterlimit="10"
							/>
						</svg>
						<svg class="alert-sign yellow-stroke">
							<g transform="matrix(1,0,0,1,-615.516,-257.346)">
								<g transform="matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)">
									<path class="line" d="M634.087,300.805L673.361,261.53" fill="none" />
								</g>
								<g transform="matrix(2.27612,-2.46519e-32,0,2.27612,-792.339,-404.147)">
									<circle class="dot" cx="621.52" cy="316.126" r="1.318" />
								</g>
							</g>
						</svg>
					</div>
				</template>
			</div>
		</template>

		<div v-if="!loading && transaction" class="content">
			<div class="p-4 flex-grow-1">
				<div v-if="transaction.status == 'PAID'">
					<div class="data data-amount">
						<div class="value">
							<span>{{ transaction.currencySymbol }}</span> {{ transaction.amount }}
						</div>
						<p>
							IMPORTANTE: En breve te enviaremos un correo electrónico donde recibirás un código QR el
							cual debes llevar impreso o en tu celular para que puedas acceder al evento.
						</p>
					</div>
					<div class="data">
						<div class="label">Número de transacción</div>
						<div class="value">{{ transaction.referencePaymentId }}</div>
					</div>
				</div>

				<div v-if="transaction.status == 'FAILED'">
					<router-link tag="a" :to="`/purchase/${transaction.order.id}`" class="btn btn-primary mt-4"
						>Reintentar pago</router-link
					>
				</div>

				<div v-if="transaction.status == 'PENDING'">
					<h5 class=" mt-3 mb-2">Pago pendiente de acreditación</h5>
					<p>
						<span class="label">IMPORTANTE:</span><br />
						Tu reserva se mantedrá por 2 horas en el sistema, si no se acredita en ese tiempo, se cancelará
						automáticamente.
					</p>
				</div>
			</div>
		</div>

		<div v-if="!loading && transaction" class="w-100 p-4 d-flex  justify-content-center">
			<router-link tag="a" to="/" class="btn btn-secondary">
				Volver al sitio
			</router-link>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Loader from "@/components/Loader"

export default {
	name: "PurchaseResult",
	components: {
		Loader
	},
	data() {
		return {
			loading: false,
			order: null,
			transaction: null
		}
	},

	async beforeMount() {
		this.loading = true
		if (!this.$route.params.transactionId) return this.$router.push("/")

		await this.loadTransaction()
		await this.transactionExecute()
		// this.loadOrder()
		this.loading = false
	},
	methods: {
		// ejecuto la transaccion
		async loadTransaction() {
			if (this.$route.params.transactionId) {
				return this.$apollo
					.query({
						query: gql`
							query($id: ID!) {
								transaction(id: $id) {
									id
									order {
										id
										status
									}
									status
								}
							}
						`,
						variables: {
							id: this.$route.params.transactionId
						}
					})
					.then(({ data }) => {
						this.transaction = data.transaction
						return data.transactionExecute
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.loading = false
					})
			}
		},

		// si el resultado es pendiente, igual intento actualizar el estado de la transaccion.
		async transactionExecute() {
			if (this.$route.params.transactionId) {
				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($id: ID!, $paymentId: ID!) {
								transactionExecute(id: $id, paymentId: $paymentId) {
									id
									referencePaymentId
									currencySymbol
									amount
									order {
										id
									}
									status
								}
							}
						`,
						variables: {
							id: this.$route.params.transactionId,
							paymentId: this.$route.query.payment_id
						}
					})
					.then(({ data }) => {
						this.transaction = data.transactionExecute
						return data.transactionExecute
					})
					.catch((error) => {
						this.parseGQLErrors(error)
					})
			}
			return null
		},

		loadOrder() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							order(id: $id) {
								id
								tickets {
									id
								}
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id: this.transaction.order.id
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.order = data.order
					return data.order
				})
		}
	}
}
</script>

<style scoped lang="scss">
.purchase-page {
	width: 100%;
	height: 100vh;
	padding: 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.purchase-head {
		width: 100%;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-grow: 1;

		h2 {
			font-size: 1.2rem;
		}
		h3 {
			font-size: 1rem;
		}
	}

	.content {
		max-width: 480px;
		border-radius: 6px;
		overflow: hidden;
		display: flex;
		border: none;
		position: relative;
		flex-grow: 1;
	}
}

.data {
	padding: 8px;
	.label {
		color: #00000090;
	}
	.value {
		font-weight: 500;
	}
}
.data-amount {
	text-align: center;
	.value {
		font-size: 1.8rem;
		span {
			font-size: 1.2rem;
		}
	}
	p {
		margin-top: 12px;
		font-size: 0.7rem;
		color: #00000090;
	}
}

.alert {
	color: #6f7287;
	background-color: #f8f7fa;
}

.svg-box {
	display: inline-block;
	position: relative;
	width: 140px;
}

.green-stroke {
	stroke: #7cb342;
}

.red-stroke {
	stroke: #ff6245;
}

.yellow-stroke {
	stroke: #ffc107;
}

.circular circle.path {
	stroke-dasharray: 330;
	stroke-dashoffset: 0;
	stroke-linecap: round;
	opacity: 0.4;
	animation: 0.7s draw-circle ease-out;
}

/*------- Checkmark ---------*/
.checkmark {
	stroke-width: 6.25;
	stroke-linecap: round;
	position: absolute;
	top: 56px;
	left: 49px;
	width: 52px;
	height: 40px;
}

.checkmark path {
	animation: 1s draw-check ease-out;
}

@keyframes draw-circle {
	0% {
		stroke-dasharray: 0, 330;
		stroke-dashoffset: 0;
		opacity: 1;
	}

	80% {
		stroke-dasharray: 330, 330;
		stroke-dashoffset: 0;
		opacity: 1;
	}

	100% {
		opacity: 0.4;
	}
}

@keyframes draw-check {
	0% {
		stroke-dasharray: 49, 80;
		stroke-dashoffset: 48;
		opacity: 0;
	}

	50% {
		stroke-dasharray: 49, 80;
		stroke-dashoffset: 48;
		opacity: 1;
	}

	100% {
		stroke-dasharray: 130, 80;
		stroke-dashoffset: 48;
	}
}

/*---------- Cross ----------*/

.cross {
	stroke-width: 6.25;
	stroke-linecap: round;
	position: absolute;
	top: 54px;
	left: 54px;
	width: 40px;
	height: 40px;
}

.cross .first-line {
	animation: 0.7s draw-first-line ease-out;
}

.cross .second-line {
	animation: 0.7s draw-second-line ease-out;
}

@keyframes draw-first-line {
	0% {
		stroke-dasharray: 0, 56;
		stroke-dashoffset: 0;
	}

	50% {
		stroke-dasharray: 0, 56;
		stroke-dashoffset: 0;
	}

	100% {
		stroke-dasharray: 56, 330;
		stroke-dashoffset: 0;
	}
}

@keyframes draw-second-line {
	0% {
		stroke-dasharray: 0, 55;
		stroke-dashoffset: 1;
	}

	50% {
		stroke-dasharray: 0, 55;
		stroke-dashoffset: 1;
	}

	100% {
		stroke-dasharray: 55, 0;
		stroke-dashoffset: 70;
	}
}

.alert-sign {
	stroke-width: 6.25;
	stroke-linecap: round;
	position: absolute;
	top: 40px;
	left: 68px;
	width: 15px;
	height: 70px;
	animation: 0.5s alert-sign-bounce cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.alert-sign .dot {
	stroke: none;
	fill: #ffc107;
}

@keyframes alert-sign-bounce {
	0% {
		transform: scale(0);
		opacity: 0;
	}

	50% {
		transform: scale(0);
		opacity: 1;
	}

	100% {
		transform: scale(1);
	}
}
</style>
